export default "__VITE_ASSET__c08488c3__"